import { useState, useEffect } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputTime from "../../helpers/InputTime";
import { UNSAFE_DataRouterStateContext } from "react-router-dom";
import InputSearchEmp from "../../helpers/InputSearchEmp";

import edit from "../../edit.png";
import back from "../../back.png";
import InputTextArea from "../../helpers/InputTextArea";


function DayHistorySet(props)
{


    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    
    const defRow = {
            id:  props.id,
            dzien:  "",      
            godzina: "",      
            tytul:  "",      
            opis: "",             
    };

    if(props.id > 0)
    {
        defRow.dzien = props.row.dzien;
        defRow.godzina = props.row.godzina;
        defRow.tytul = props.row.tytul;
        defRow.opis = props.row.opis;
    }

    const [row, setRow] = useState(defRow);



     const valChangeListener = (filedName, val, correct, msg) => {      
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }





      const saveData = () => {

 
        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }


           
        if(row.dzien.length < 2) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Wskaż dzień' ,  "ok"  ,null); 
                return; 
            }


        
        if(row.tytul.length < 2) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Podaj tytuł' ,  "ok"  ,null); 
                return; 
            }


        if(row.opis.length < 100) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Podaj opis, min. 100 znaków' ,  "ok"  ,null); 
                return; 
            }
       
        
 
        props.mainView.setProgress(-2);

        var req =  row;


        fetch( Config.url + '/rest_v1_news,dziennik_dnia_set', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

               

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Informacje zostały zapisane" , "ok" , null);    
                       if(props.onBack != undefined) props.onBack(res.result);
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
         
                   

         return false;

    }





    return (
          <div className="view_content">

                 <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                <form className="eForm bg_center">

                        <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Dzień*</div>
                                                <InputDate   userData={props.userData} value={row.dzien} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={"Dzień: "} className=' ' req='1' firstUp="1" />
                                            </div>

                                              <div className="form_control">
                                                <div className="fieldName">Godzina (puste jeśli cały dzień)</div>
                                                <InputTime   userData={props.userData} value={row.godzina} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina" placeholder={"Godzina: "} className=' ' req='0' firstUp="0" />
                                            </div>
                                            
                                            <div className="form_split"></div>
                                            
                                            <div className="form_control">
                                                <div className="fieldName">Tytuł / Temat*</div>
                                                <InputText   userData={props.userData} value={row.tytul} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tytul" placeholder={"Tytuł: np. Wyjście do kina"} className=' w300 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Opis, co się działo tego dnia?*</div>
                                                <InputTextArea   userData={props.userData} value={row.opis} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Opis / Szczegóły: "} className=' w400 h300 ' req='1' firstUp="1" />
                                            </div>

                        </div>


                        <div className="form_split"></div>

                                    <div className="form_btn">
                                            <div className="btn" onClick={saveData}>zapisz</div>
                                            &nbsp;&nbsp;
                                            <div className="btn" onClick={props.onBack}    > anuluj</div>
                                    </div>


                </form>

          </div>
    )
}


export default DayHistorySet;